<template>
  <div>
    <va-modal
      v-model="showModal"
      id="leadDetailsModal"
      ref="leadDetailsModal"
      :cancelText="$t('leads.back')"
      size="large"
      :showOkay="false"
      :hideDefaultActions="isMobile"
      @cancel="$emit('cancel')"
      :fixedLayout="true">

      <div slot="header" class="d-flex justify--space-between">
          <span :class="{'col-width': isMobile}">
            <span><b style="font-size:22px; margin-bottom: 1rem; font-weight: bold"
                     class="mr-2"> {{ headerTitle | capitalize }}</b></span>
          </span>

        <!--<va-popover
          placement="top"
          :message="selectedLead.person.email === null ? $t('dashboard_new_evollu.send_pdf_no_email') : $t('dashboard_new_evollu.send_pdf')">
          <va-button large icon="fa fa-envelope" color="#29C4AA" @click.prevent="sendReportEmail()"
                     :disabled="isSendingReportEmail || selectedLead.person.email === null"></va-button>
        </va-popover>-->

        <span class="close-modal-button" v-if="isMobile">
          <va-button icon="fa fa-times" @click.prevent="$emit('cancel')"></va-button>
        </span>
      </div>


      <!-- Person information -->
      <div class="row">
        <h3>{{ $t('evohealth.patient.details_title') }}</h3>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('people_manager.table.name') }}:
            </span>
          {{ selectedLead.person ? selectedLead.person.name ? selectedLead.person.name : 'N/A' : 'N/A' }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('people_manager.table.phone') }}:
            </span>
          {{ selectedLead.person && selectedLead.person.mobilePhone ? selectedLead.person.mobilePhone : 'N/A' }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('people_manager.table.email') }}:
            </span>
          {{ selectedLead.person && selectedLead.person.email ? selectedLead.person.email : 'N/A' }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('people_manager.table.birthdate') }}:
            </span>
          {{ selectedLead.person && selectedLead.person.birthdate ? moment.utc(selectedLead.person.birthdate).locale('pt').local().format('YYYY-MM-DD') : 'N/A' }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('people_manager.table.gender') }}:
            </span>
          {{ selectedLead.person && selectedLead.person.gender ? $t(`genders.${selectedLead.person.gender}`) : 'N/A' }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('people_manager.tax_nr') }}:
            </span>
          {{ selectedLead.person && selectedLead.person.taxNr ? selectedLead.person.taxNr : 'N/A' }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3" v-if="selectedLead.person && selectedLead.person.healthNr">
            <span class="is-bold">
              {{ $t('people_manager.health_nr') }}:
            </span>
          {{ selectedLead.person && selectedLead.person.healthNr ? selectedLead.person.healthNr : 'N/A' }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('people_manager.table.address') }}:
            </span>
          {{ handleAddress() }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('people_manager.table.country') }}:
            </span>
          {{ selectedLead.person && selectedLead.person.country ? countries.find(elem => elem.code === selectedLead.person.country.toUpperCase()).name : 'N/A'
          }}
        </div>
      </div>

      <hr class="separator-lead-details">

      <div class="row">
        <h3>{{ $t('biosigns.lead_details_title') }}</h3>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{ $t('biosigns.columns.entity') }}:
            </span>
          {{ selectedLead.entity ? selectedLead.entity.name : 'N/A' }}
        </div>
      </div>

      <div v-if="data !== null">
        <div class="row col-12" v-for="group in Object.keys(data)">
          <div class="col-12">
            <div style="background-color: #ededed; border-radius: 6px" class="pt-2 pb-1 pl-2">
              <h4>{{ $t(`evohealth.healthGroups.${group}`) }}</h4>
            </div>

            <div class="row" v-for="(elem, index) in data[group] " :class="{'mt-3': index !== 0}">

              <div class="col-12 col-md-6" v-for="value in elem" :key="value.id">
                <span class="is-bold">{{$t(`evohealth.healthParameters.${value.healthParam.name}`)}}</span>: <span>{{extractValue(value.healthParam, value)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </va-modal>
  </div>
</template>

<script>
import * as countries from 'i18n-iso-countries';
import Vue from 'vue';
import { EvohealthService } from '@/api/EvohealthService';

export default {
  props: {
    selectedLead: {
      type: Object,
      required: true,
    },
    healthParams: {
      type: Array,
      required: true,
    },
    healthGroup: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      showModal: false,
      data: {},
      isSendingReportEmail: false
    }
  },
  mounted() {
    this.showModal = true;

    //const groupedByHealthArea = {};
    const data = {}

    //console.log(this.selectedLead)

    const healthGroupLeadValues = {
      ...this.selectedLead.values.find(elem => elem.healthGroupId === this.healthGroup.id)
    }

    healthGroupLeadValues.leadValues.forEach(leadValue => {
      if (this.hiddenParams.includes(leadValue.healthParam.name)) return;
      if(!data[this.healthGroup.name]) data[this.healthGroup.name] = []
      data[this.healthGroup.name].push(leadValue)
    });
    //this.data = groupedByHealthArea;
    //this.data = data

    const result = {};

    // percorre cada grupo (ex: "BloodPressure")
    for (const [groupName, measurements] of Object.entries(data)) {
      result[groupName] = [];

      // vamos agrupar por índice, assumindo que cada "conjunto" tem todos os parâmetros (SBP, DBP, HR, etc)
      let grouped = [];
      // ordem esperada de parâmetros (podes adaptar)
      const expectedParams = [...new Set(measurements.map(m => m.healthParam.name))];
      // itera pelos valores e agrupa cada conjunto de medições
      for (let i = 0; i < measurements.length; i += expectedParams.length) {
        grouped.push(measurements.slice(i, i + expectedParams.length));
      }
      // nomeia value0, value1, etc.
      grouped.forEach((set, index) => {
        result[groupName].push(set);
      });

    }
    console.log(result)
    this.data = result

  },
  methods: {

    sendReportEmail: async function() {
      try {
        this.isSendingReportEmail = true
        await EvohealthService.sendReportEmail(this.selectedLead.id, this.healthGroup.id)
        this.showToast(this.$t('dashboard_new_evollu.pdf_sent_successfully'), this.$store.state.successToastOptions)
      } catch (err) {
        console.log(err)
        this.showToast(this.$t('dashboard_new_evollu.pdf_not_sent'), this.$store.state.errorToastOptions)
      } finally {
        this.isSendingReportEmail = false
      }

    },
    handleAddress: function() {
      let addressStr = '';
      if (this.selectedLead.person) {
        if (this.selectedLead.person && this.selectedLead.person.addressLine) {
          addressStr += this.selectedLead.person.addressLine + ' ';
        }
        if (this.selectedLead.person.country.toLowerCase() === 'pt') {
          if (this.selectedLead.person.concelho) {
            addressStr += this.selectedLead.person.concelho.name;
          }
          if (this.selectedLead.person.concelho && this.selectedLead.person.concelho.distrito) {
            addressStr += ', ' + this.selectedLead.person.concelho.distrito.name + ' ';
          } else {
            addressStr += ' ';
          }
        } else {
          if (this.selectedLead.person.county) {
            addressStr += this.selectedLead.person.county + ' ';
          }
        }

        if (this.selectedLead.person.postalCode) {
          addressStr += this.selectedLead.person.postalCode + ' ';
        }
      }
      return addressStr === '' || addressStr === ' ' ? 'N/A' : addressStr;
    },
    extractValue: function(healthParam, leadValue) {
      if (this.selectedLead.values === null || this.selectedLead.values.length === 0) {
        return 'N/A';
      }

      //const leadValue = this.selectedLead.values[0].leadValues.find(val => val.healthParam.id === healthParam.id)
      if (leadValue && leadValue.value !== '' && leadValue.value !== null && leadValue.value !== undefined && leadValue.value !== 'null') {
        let valueText = leadValue.value;
        if(healthParam.name === 'levelOfConsciousness') {
          return this.$t(`evohealth.healthParameters.news2.levelOfConsciousnessOptions.${valueText}`, "N/A")
        }
        if(healthParam.name === 'supplementaryOxygenAdministered'){
          return this.$t(`clinical.labels.${valueText}`, "N/A")
        }
        if (healthParam.unit) valueText += ` ${healthParam.unit}`;
        return valueText;
      }

      return 'N/A';
    },
  },
  computed: {
    hiddenParams: function() {
      return [];
    },
    isMobile: function() {
      return window.matchMedia(`(max-width: 767px)`).matches || window.matchMedia(`(max-height: 400px)`).matches;
    },
    headerTitle: function() {
      let header = '';
      header += `${this.selectedLead.person ? this.selectedLead.person.name ? this.selectedLead.person.name : 'N/A' : 'N/A'} - ${this.$options.filters.localTime(this.selectedLead.createdAt, 'YYYY-MM-DD HH:mm')}`;
      return header;
    },
    countries: function () {
      for (let code of this.$store.state.countries.allowed) {
        if (code.toLowerCase() === "gb") {
          code = "en"
        } else if (code.toLowerCase() === 'cz') {
          code = 'cs'
        }
        countries.registerLocale(require(`i18n-iso-countries/langs/${code.toLowerCase()}.json`))
      }
      let vueI18nLocale = Vue.i18n.locale().toLowerCase()
      switch (vueI18nLocale) {
        case 'gb':
          vueI18nLocale = 'en'
          break;
        case 'cz':
          vueI18nLocale = 'cs'
          break;
      }
      let tempCountries = countries.getNames(vueI18nLocale)
      let countriesList = []
      for(const key in tempCountries) {
        countriesList.push({
          name: tempCountries[key],
          code: key
        })
      }
      return countriesList
      //return CountryList.filter(country => this.$store.state.countries.allowed.includes(country.code))
      //return CountryList
    },
    /*countries: function() {
      for (let code of this.$store.state.countries.allowed) {
        if (code.toLowerCase() === 'gb') {
          code = 'en';
        }
        countries.registerLocale(require(`i18n-iso-countries/langs/${code.toLowerCase()}.json`));
      }
      let tempCountries = countries.getNames(Vue.i18n.locale().toLowerCase() === 'gb' ? 'en' : Vue.i18n.locale().toLowerCase());
      let countriesList = [];
      for (const key in tempCountries) {
        countriesList.push({
          name: tempCountries[key],
          code: key,
        });
      }
      return countriesList;
    },*/
  }
};
</script>

<style scoped lang="scss">

</style>
